
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discount-tire",
      function () {
        return require("private-next-pages/discount-tire.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discount-tire"])
      });
    }
  